<template>
  <footer
    class="basic-block lp-footer"
    :class="[`lp-footer--${lpId}`]"
    :style="styles"
  >
    <div class="lp-footer__inner">
      <div class="uranaitv-logo">
        <a href="/"><img src="/static/img/common/header/uranaitv_logo.svg"></a>
      </div>
      <!--
      <div class="terms-area">
        <p>株式会社ザッパラスは、ご入力いただいた情報を、占いサービスを提供するためにのみ使用し、情報の蓄積を行ったり、他の目的で使用することはありません。当社<a href="/privacy">プライバシーポリシー</a>をご確認の上、必要情報をご入力ください。また、ご利用に関しては、<a href="/terms">利用規約</a>に同意の上、必要情報をご入力ください。</p>
        <p>※メルマガ配信について※<br>アカウント登録や各種決済の都度、確認のメールをお送りしているほか、メールによるお知らせが配信される場合がございます。メルマガの解除はこちらからお願いいたします。</p>

        <a href="/user/account/magazine"><p>メールマガジンを管理</p></a>

        <p>・メルマガの内容について<br>新しい占いや割引情報などお得な情報をお送り致します。</p>
        <p>・メルマガ配信の頻度について<br>不定期</p>
      </div>
      <div class="menus">
        <ul>
          <li v-for="(item, index) in menuList" :key="index">
            <a
              :href="item.url"
              :target="/^http/.test(item.url) ? '_blank' : ''"
            >{{item.label}}</a>
          </li>
        </ul>
      </div>
      <ul class="lp-footer__sns">
        <li v-for="(v, i) in snsList" :key="i">
          <a :href="v.url" target="_blank">
            <img :src="`/static/img/common/sns_${v.label}.png`" :alt="v.label" width="40">
          </a>
        </li>
      </ul>
      -->
    </div>
    <div v-if="showToTopBtn" :class="['lp-footer__to-top', showToTop ? 'lp-footer__to-top--show' : '']" @click="toTop" :style="{bottom: `${toTopPos}px`}">
      <img src="/static/img/common/arrow_up_white.png" alt="" width="18">
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LpFooter',
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    lpId: {
      type: Number,
      default: 1,
    },
    isLpTop: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      default(){
        return []
      },
    },
    showToTopBtn: {
      type: Boolean,
      default: true,
    },
    hasFloatingBanner: {
      type: Boolean,
      default: false,
    },
    scrollPos: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // showToTop: false,
      snsList: [
        // { label: 'twitter', url: 'https://twitter.com/agarutv' },
        { label: 'instagram', url: 'https://www.instagram.com/uranai_tv/' },
        // { label: 'line', url: 'https://lin.ee/CxoTFVj' },
        { label: 'line', url: 'https://liff.line.me/1656812190-7Ne8L3nP/landing?follow=%40401ymcbi&lp=YUu5D1&liff_id=1656812190-7Ne8L3nP' },
      ],
    }
  },
  computed: {
    toTopPos() {
      return this.hasFloatingBanner ? 144 : 10
    },
    styles(){
      return {
        '--key-color': !!this.colorScheme.keyColor && this.colorScheme.keyColor.length > 0 ? this.colorScheme.keyColor : '#ff7497',
        '--font-color': !!this.colorScheme.fontColor && this.colorScheme.fontColor.length > 0 ? this.colorScheme.fontColor : 'white',
        '--second': !!this.colorScheme.second && this.colorScheme.second.length > 0 ? this.colorScheme.second : '#ff7497',
      }
    },
    showToTop() {
      return this.scrollPos > window.innerHeight * 0.5
    },
  },
  created() {
    if (this.isLpTop) {
      // [0]を削除
      this.menuList.splice(0, 1)
    }
  },
  methods: {
    toTop() {
      window.scroll({ top: 0, behavior: "smooth"})
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_font: var(--font-color);
$l_col_key: var(--key-color);
$l_col_second: var(--second);

.lp-footer {
  color: $l_col_font;
  background: $l_col_key;
  padding: 40px 0 60px;
  &--5 {
    background: #FF6AB2;
  }
  a {
    color:$l_col_font;
    text-decoration: none;
  }
  &__inner {
    padding: 0 20px;
  }
  .uranaitv-logo {
    margin: 0 auto 20px;
    text-align: center;
    img {
      width: 82px;
    }
  }
  .menus {
    margin: 0 0 40px;
    ul {
      padding: 0;
      margin: 0 -7px 0 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      font-size: 13px;
      line-height: 19px;
      > li {
        flex: 1 1 50%;
        max-width: 50%;
        padding: 0 7px 0 0;
        margin: 0;
        @include mq('w768') {
          flex-basis: 33.33%;
          max-width: 33.33%;
        }
        a {
          border-bottom: 1px solid;
          display: block;
          padding: 20px 0 17px;
          text-align: center;
        }
      }
    }
  }
  &__sns {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    justify-content: flex-end;
    > li {
      padding: 0;
      margin: 0;
      + li {
        margin-left: 24px;
      }
    }
  }
  &__to-top {
    background: $l_col_second;
    position: fixed;
    right: 20px;
    //bottom: 10px;
    z-index: 100;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    cursor: pointer;
    opacity: 0;
    visibility: hidden;
    transform: translate(0, 10px);
    transition: all 0.3s ease-in-out 0s;
    @include mq('w768') {
      right: unset;
      margin-left: 600px;
    }
    &--show {
      opacity: 0.75;
      transform: translate(0, 0);
      visibility: visible;
    }
  }
}
.terms-area{
  padding: 20px;
  background: #f2f2f2;
  p,a{
    font-size: 10px;
    color: #32373f;
  }
  a{
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/LpFooter.vue